import styled from "styled-components";
import { colors } from "../../styles/Colors";
import { TextBold } from "../../styles/GlobalStyledComponents";

export const UnavailableImageWrapper = styled.div`
    width: 100%;
    height: 100%;
    display: flex;
    justify-content: center;
    margin-top: 3.5rem;
`;

export const UnavailableImage = styled.img`
    width: 100px;
`;

export const UnavailableLink = styled.a`
    color: ${colors.red6};
    text-decoration: underline;
    font-size: 14px;
    font-weight: 600;
    margin: 14px 0;
`;

export const UnavailableContainer = styled.div`
    display: flex;
    flex-direction: column;
`;

 export const TextTel = styled(TextBold)`
    white-space: nowrap;
  `;
